/**
 * Lets `makeRequest` update React auth state after a Cognito token refresh
 * without importing AuthContext into the API client (avoids circular deps).
 */

export type RefreshedOrgTokens = { idToken: string; refreshToken: string };

type Listener = (tokens: RefreshedOrgTokens) => void;

let listener: Listener | null = null;

export function registerOrgTokenRefreshListener(fn: Listener | null): void {
  listener = fn;
}

export function notifyOrgTokensRefreshed(tokens: RefreshedOrgTokens): void {
  listener?.(tokens);
}
